import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'incapacity-reasons',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'incapacity-reasons-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.incapacity-reasons-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "incapacity-reasons-index" */ '@/modules/configurations/catalogs/incapacity-reasons/views/Index.vue')
        },
        {
            path: 'create',
            name: 'incapacity-reasons-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'incapacity-reasons-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.incapacity-reasons-index',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.incapacity-reasons-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "incapacity-reasons-create" */ '@/modules/configurations/catalogs/incapacity-reasons/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'incapacity-reasons-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'incapacity-reasons-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.incapacity-reasons-index',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.incapacity-reasons-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "incapacity-reasons-edit" */ '@/modules/configurations/catalogs/incapacity-reasons/views/Edit.vue')
        }
    ]
}
